// src/components/ImportToken.js
import React, { useState } from "react";
import { Input, Button, message } from "antd";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20.json";
import { saveToken } from "../utils/tokenStorage";
import { CHAINS_CONFIG } from "../chains";

function ImportToken({ address, selectedChain, onImported }) {
  const [tokenAddress, setTokenAddress] = useState("");
  const [loading, setLoading] = useState(false);

  const importToken = async () => {
    if (!tokenAddress) return;

    try {
      setLoading(true);

      const chain = CHAINS_CONFIG[selectedChain];
      if (!chain || !chain.rpcUrl) {
        message.error("Unsupported chain");
        return;
      }

      const provider = new ethers.JsonRpcProvider(chain.rpcUrl);

      const contract = new ethers.Contract(
        tokenAddress.trim(),
        ERC20ABI,
        provider
      );

      const symbol = await contract.symbol();

      // ✅ Force decimals for USDT0 on Polygon
      let decimals;
      if (
        tokenAddress.toLowerCase() ===
        "0xc2132d05d31c914a87c6611c10748aeb04b58e8f"
      ) {
        decimals = 6; // Polygon USDT decimals
      } else {
        decimals = Number(await contract.decimals());
      }

      saveToken(selectedChain, {
        address: tokenAddress.trim(),
        symbol,
        decimals,
        chainId: selectedChain,
      });

      message.success(`Token ${symbol} imported`);
      setTokenAddress("");
      onImported?.();
    } catch (e) {
      console.error("IMPORT ERROR:", e);
      message.error("Invalid token or wrong network");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: 15 }}>
      <Input
        placeholder={`Token address on ${CHAINS_CONFIG[selectedChain]?.name}`}
        value={tokenAddress}
        onChange={(e) => setTokenAddress(e.target.value)}
      />

      <Button
        type="primary"
        block
        loading={loading}
        style={{ marginTop: 8 }}
        onClick={importToken}
      >
        Import Token
      </Button>
    </div>
  );
}

export default ImportToken;